export default __webpack_public_path__ + "static/media/authorbg04.5014bba4.jpg";